import { GridColumn, GridRow } from 'app/layouts/grid';
import { plans } from './data/plans';
import styles from './comparison.module.css';
import React, { useEffect, useState } from 'react';
import { useCurrencyService } from 'hooks/sales/currency';
import { toReadableNumber } from 'app/shared/utils/number';
import { Button } from 'app/shared/button';

export const PricingComparison = ({
  contact_bracket = { min: 0, max: 0 },
  renewal_period = 'month',
  currency = 'NGN',
  modules = [],
  onGetStarted = () => {},
  onBookCall = () => {}
}) => {
  const { getCurrencySymbol } = useCurrencyService();

  const [disabled_modules, setDisabledModules] = useState({});
  const [is_book_demo, setIsBookDemo] = useState(false);

  useEffect(() => {
    setDisabledModules({});
    setIsBookDemo(false);
    if (contact_bracket.min > 49999) setDisabledModules((prev) => ({ ...prev, explorer: true }));
    if (contact_bracket.min > 199999)
      setDisabledModules((prev) => ({ ...prev, professional: true }));
    if (contact_bracket.min > 249999) {
      setIsBookDemo(true);
    }
  }, [currency, contact_bracket, renewal_period]);

  const determinePricing = (module, contact_bracket) => {
    const sorted_pricing = module.pricing.sort(
      (a, b) => a.contact_bracket.min - b.contact_bracket.min
    );
    const target_pricing = sorted_pricing.find((pricing) => {
      const { min, max } = pricing.contact_bracket;
      return contact_bracket.min === min && contact_bracket.max === max;
    });

    if (!target_pricing) {
      return 0;
    }

    return target_pricing.prices.find((p) => p.currency === currency)?.amount || 0;
  };

  return (
    <div className={styles.pricingComparison}>
      <div className={styles.planHeader}>
        <GridRow num_of_columns={4} style={{ marginBottom: '0', gap: '0' }}>
          <GridColumn>
            <div className={styles.planComparisonTitle}>
              <h4>Pick Your plan</h4>
              <p>
                See how our plans stack up against each other and find the one that’s right for you.
              </p>
            </div>
          </GridColumn>
          {modules.map((module) => (
            <GridColumn key={module}>
              <div className={styles.planInfo}>
                <div className={styles.planName}>{module.title}</div>
                <div className={styles.planPriceWrapper}>
                  <div>Starts at </div>
                  <span className={styles.planPrice}>
                    {getCurrencySymbol(currency)}
                    {toReadableNumber(determinePricing(module, contact_bracket) || 0)}
                  </span>{' '}
                  /month
                </div>
                <div className={styles.planAction}>
                  <Button
                    text={
                      disabled_modules[module.tier]
                        ? 'Bracket exceeded'
                        : is_book_demo
                        ? 'Talk to Sales'
                        : 'Select plan'
                    }
                    disabled={disabled_modules[module.tier]}
                    onClick={() => (is_book_demo ? onBookCall(module) : onGetStarted(module))}
                  />
                </div>
              </div>
            </GridColumn>
          ))}
        </GridRow>
      </div>
      <div>
        {plans.map((plan) => (
          <div key={plan.group} className={styles.planGroup}>
            <div className={styles.planGroupTitle}>{plan.group}</div>
            <div>
              {plan.features.map((feature) => (
                <div key={feature.key} className={styles.feature}>
                  <GridRow num_of_columns={4} style={{ marginBottom: '0px', gap: '0' }}>
                    <GridColumn>
                      <div className={styles.featureKey}>{feature.key}</div>
                    </GridColumn>
                    {feature.values.map((value, index) => (
                      <GridColumn key={index}>
                        <div className={styles.featureValue}>{value}</div>
                      </GridColumn>
                    ))}
                  </GridRow>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
